import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getSetupAuditTrailEvents } from '@api';

export const getCoreSetupAuditTrailSlice = createGetAsyncSlice({
	name: 'CoreSetupAuditTrail',
	receive: true,
	request: true,
	requestHandler: getSetupAuditTrailEvents,
	retainDataOnRequest: true
});
